import * as tslib_1 from "tslib";
import RichText from '@ivy/fts/comps/RichText.vue';
import { env } from '@ivy/fts/envInfo/envInfo';
import { isXcxWeb } from '@ivy/fts/utils';
import { addStatistics, vw2px } from '../require';
import { Component, Vue, Prop } from 'vue-property-decorator';
let GoodsInfo = class GoodsInfo extends Vue {
    constructor() {
        super(...arguments);
        this.currentIndex = 0;
        this.isFixed = false;
        this.reqId = null;
        this.tabTop = 0;
        this.windowHeight = 0;
        this.scrollHeight = 0;
        this.tabCurrentIndex = 0;
        this.contentList = [];
        this.tabpaneHeightList = [];
    }
    get style() {
        return this.isFixed && this.isApp
            ? { top: 40 + this.navbarHeight + 'px' }
            : '';
    }
    get introductionCourse() {
        if (this.spu && this.spu.introductionCourse) {
            return this.spu.introductionCourse;
        }
        return [];
    }
    get list() {
        let list = [];
        if (this.spu) {
            this.spu.introduction ? list.push({ title: '课程详情', id: 0 }) : '';
            if (this.spu.introductionCourse) {
                this.spu.introductionCourse = this.spu.introductionCourse.filter(item => !this.isTrim(item.text) ? item : null);
            }
            ;
            (this.spu.introductionCourse &&
                this.spu.introductionCourse.length > 0) ||
                this.spu.introductionCourseContent
                ? list.push({ title: '课程大纲', id: 1 })
                : '';
            this.spu.introductionQuestion
                ? list.push({ title: '常见问题', id: 2 })
                : '';
        }
        return list;
    }
    get xcxWeb() {
        return isXcxWeb();
    }
    get tabStyle() {
        return `transform:translate3d(-${this.tabCurrentIndex *
            100}%,0px,1px);touch-action: pan-x pan-y;`;
    }
    mounted() {
        if (this.spu && this.spu.introductionCourseContent && this.listen) {
            this.getContentList();
        }
        this.$nextTick(() => {
            if (this.introductionCourse.length > 1) {
                const tabs = this.$refs.navbar;
                if (tabs.scrollWidth <= tabs.clientWidth) {
                    tabs.style = 'justify-content:center';
                }
            }
        });
        setTimeout(() => {
            window.addEventListener('scroll', this.scrollEvent);
            if (this.list.length > 1) {
                this.getHeight();
            }
        }, 1000);
    }
    destroyed() {
        window.removeEventListener('scroll', this.scrollEvent);
    }
    getHeight() {
        const tabs = this.$refs.tabs;
        this.isApp
            ? (this.tabTop = tabs.offsetTop - tabs.offsetHeight)
            : (this.tabTop = tabs.offsetTop);
        this.list.forEach((item, index) => {
            const tabpane = this.$refs[`tabpane-${item.id}`];
            this.isApp // app要减去顶部的高度
                ? this.tabpaneHeightList.push(tabpane.offsetTop -
                    tabs.offsetHeight -
                    this.navbarHeight -
                    40 * vw2px())
                : this.tabpaneHeightList.push(tabpane.offsetTop - tabs.offsetHeight);
        });
        return this.tabpaneHeightList;
    }
    adjustVideo(item) {
        return item.replace('<video ', '<video  webkit-playsinline="true" playsinline="true"');
    }
    async scrollEvent() {
        this.windowHeight =
            document.documentElement.clientHeight || document.body.clientHeight;
        this.scrollHeight =
            document.body.scrollHeight || document.documentElement.scrollHeight;
        const scrollTop = window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
        scrollTop >= this.tabTop ? (this.isFixed = true) : (this.isFixed = false);
        this.tabpaneHeightList.map((item, i) => {
            const min = i === 0 ? 0 : item;
            const max = i === this.tabpaneHeightList.length - 1
                ? null
                : this.tabpaneHeightList[i + 1];
            if (scrollTop + 3 >= min && (scrollTop - 3 <= max || max === null)) {
                let old = this.currentIndex;
                this.currentIndex = i;
                if (this.currentIndex !== old) {
                    // 埋点 商品介绍页曝光
                    addStatistics({
                        event: 'ExposureTimes_GoodDetails_IntroductionPage_H5',
                        p1: this.$route.query.nativeFrom,
                        p2: this.point,
                        p3: this.list[this.currentIndex],
                        p4: this.goodsStatus,
                    });
                }
            }
        });
        if (scrollTop + this.windowHeight === this.scrollHeight) {
            //滑动到底时，防止最后的tab不够满屏
            this.currentIndex = this.list.length - 1;
            // 埋点 商详页查看完成
            addStatistics({
                event: 'Display_GoodDetails_Finish_H5',
                p1: this.$route.query.nativeFrom,
                p2: this.point,
                p3: this.goodsStatus,
            });
            // 埋点 商品介绍页曝光
            addStatistics({
                event: 'ExposureTimes_GoodDetails_IntroductionPage_H5',
                p1: this.$route.query.nativeFrom,
                p2: this.point,
                p3: this.list[this.currentIndex],
                p4: this.goodsStatus,
            });
        }
    }
    errorImg(e) {
        e.target.src =
            'http://exploiter-beta.oss-cn-beijing.aliyuncs.com/tools/upload/22052009-bee1-9874-c6b5-9a626b042d16.png';
    }
    isTrim(val) {
        const regex = /<\/?(?!img|video)[a-z]+?[^>]*>/gm;
        let str = val.replace(regex, ''); // 去掉除了img 的标签
        if (str.replace(/&nbsp;/gi, '').trim() === '') {
            // 去掉空格
            return true;
        }
        else {
            return false;
        }
    }
    currentIndexChange(i) {
        // 埋点 商品介绍页曝光
        addStatistics({
            event: 'ExposureTimes_GoodDetails_IntroductionPage_H5',
            p1: this.$route.query.nativeFrom,
            p2: this.point,
            p3: this.list.find(item => item.id === i).title,
            p4: this.goodsStatus,
        });
        this.tabpaneHeightList = [];
        this.getHeight();
        const tabpane = this.$refs[`tabpane-${i}`];
        const tabs = this.$refs.tabs;
        this.$nextTick(() => {
            let tabHeight = 0;
            this.isApp
                ? (tabHeight =
                    tabpane.offsetTop -
                        tabs.offsetHeight -
                        this.navbarHeight -
                        40 * vw2px())
                : (tabHeight = tabpane.offsetTop - tabs.offsetHeight);
            this.doScroll(tabHeight);
        });
    }
    scrollStep(s) {
        document.documentElement.scrollTop = document.body.scrollTop = s;
    }
    doScroll(tabS) {
        let canScrollTop = document.documentElement.scrollHeight -
            document.documentElement.offsetHeight;
        tabS = Math.min(tabS, canScrollTop);
        let c = document.documentElement.scrollTop || document.body.scrollTop;
        const self = this;
        let addOnce = true;
        this.reqId && cancelAnimationFrame(this.reqId);
        this.reqId = window.requestAnimationFrame(() => {
            ;
            (function scrollFn(t, c, p) {
                let r = Date.now() - t;
                if (r <= 500) {
                    // 保证在500ms内完成滚动
                    var step = (function (e, t, n, a) {
                        var l = n - t;
                        let ddd = (e /= a / 2);
                        if (ddd < 1) {
                            return (l / 2) * e * e + c; // 时间为e，初始位置c,加速为1时的位移(滚动距离)
                        }
                        else {
                            return (-l / 2) * (--e * (e - 2) - 1) + t;
                        }
                    })(r, c, p, 500);
                    self.scrollStep(step);
                    window.requestAnimationFrame(function () {
                        scrollFn(t, c, p);
                    });
                }
                else if (c < tabS && addOnce) {
                    addOnce = false;
                    self.scrollStep(tabS);
                }
            })(Date.now(), c, tabS);
        });
    }
    async getContentList() {
        let { data } = await this.$axios.get('/api/mobile/knowlege/course/getCourseLessonList', {
            params: {
                id: this.listen.id,
                orderBy: 'ASC',
                limit: 20,
                offset: 0,
                isNew: 1,
            },
        });
        this.contentList = data;
    }
    async linsten(item) {
        // 埋点 商详页课程大纲点击播放
        await addStatistics({
            event: 'Click_GoodDetails_CourseOutline_play_H5',
            p1: this.point,
            p2: item.type,
            p3: item.course_id,
            p4: this.goodsStatus,
        });
        if (item.is_try) {
            if (this.isApp) {
                // await env.init()
                let options = {
                    course_type: this.listen.virtual_type,
                    content_type: this.listen.content_type,
                    from: 'product-details-page',
                    id: this.listen.id,
                };
                await this.$emit('intellect-statistics', 'stay');
                await env.toCourseAudition(options);
            }
            else {
                let listenHref = this.listen.href;
                listenHref = this.xcxWeb
                    ? listenHref.replace('http:', 'https:').replace('/age3?', '/age3/?')
                    : this.listen.href;
                let spuId = this.$route.query.spuId;
                console.log(listenHref, 'listenHref==========>', `${listenHref}&try_listen=1&spuId=${spuId}`);
                // 这里sentry报了一个异常
                window.location.href = `${listenHref}&try_listen=1&spuId=${this.$route.query.spuId}`;
            }
        }
        else {
            this.$Toast('请购买后试听哦～');
        }
    }
    tabIndexChange(index) {
        this.tabCurrentIndex = index;
    }
};
tslib_1.__decorate([
    Prop()
], GoodsInfo.prototype, "navbarHeight", void 0);
tslib_1.__decorate([
    Prop()
], GoodsInfo.prototype, "isApp", void 0);
tslib_1.__decorate([
    Prop()
], GoodsInfo.prototype, "spu", void 0);
tslib_1.__decorate([
    Prop()
], GoodsInfo.prototype, "listen", void 0);
tslib_1.__decorate([
    Prop()
], GoodsInfo.prototype, "point", void 0);
tslib_1.__decorate([
    Prop()
], GoodsInfo.prototype, "goodsStatus", void 0);
GoodsInfo = tslib_1.__decorate([
    Component({
        components: {
            RichText,
        },
    })
], GoodsInfo);
export default GoodsInfo;
